import { TitleWithBody } from '../types/new-car-offers'

/**
 * The content here is formatted in the same way as the parsed JSON that comes back from Storyblok.
 * I decided to structure it in this way for parity with the other landing content driven pages, and so it's ewasier to swap storyblok in later on when we have more time
 */
export const OUR_OFFERS_CONTENT: TitleWithBody = {
  title: 'See the latest new car offers',
  body: {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        content: [
          {
            text: 'Select a manufacturer below to see their latest offers on new cars and to find your closest store. ',
            type: 'text',
          },
        ],
      },
    ],
  },
}
